export default __webpack_public_path__ + "static/dochq-brochure-226cd5e13001d47a854bcbf6d7e2ba63.pdf";